import React from 'react';

const QuestionsReponses: React.FC = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Questions/Reponses</h1>
      <p>Contenu de la page Questions/Reponses à implémenter.</p>
    </div>
  );
};

export default QuestionsReponses;